export enum CompanyFlags {
  None = 0,
  ProvideAssets = 1 << 0,
  ProvidesTrucks = 1 << 1,
  Hidden = 1 << 2,
  External = 1 << 3,
  ProvidesMaintenance = 1 << 4
}
export const CompanyFlagsMapping: Record<CompanyFlags, string> = {
  [CompanyFlags.None]: 'Manual',
  [CompanyFlags.ProvideAssets]: 'Provides Non-Truck Equipment',
  [CompanyFlags.ProvidesTrucks]: 'Provides Trucks',
  [CompanyFlags.Hidden]: 'Deprecated',
  [CompanyFlags.External]: 'External',
  [CompanyFlags.ProvidesMaintenance]: 'Provides Maintenance'
};
